import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  nominalHeaderTxtStyles: { marginLeft: 16, marginTop: 16 },
});
export default styles;
